import CssBaseline from "@material-ui/core/CssBaseline";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import {
  createMuiTheme,
  MuiThemeProvider,
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import jwt from "jsonwebtoken";
import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import CustomerGroups from "./components/CustomerGroups/CustomerGroups";
import Dashboard from "./components/Dashboard";
import Documentation from "./components/Documentation";
import Effects from "./components/Effects";
import ErrorSnackbar from "./components/ErrorSnackbar";
import Geoselection from "./components/Geoselection";
import Impressum from "./components/Impressum";
import MarketShare from "./components/MarketShare";
import NbaEvaluation from "./components/NbaEvaluation";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import UserManagement from "./components/UserManagement";
import SignIn from "./containers/SignIn";
import HostService from "./services/Host";
import { StoreState } from "./store";
import { RoleType } from "./types/index";
import { DDATheme } from "./types/Theme";
import { isFeatureEnabled } from "./utilities";

function mapStateToProps({ auth: { token } }: StoreState) {
  return {
    token,
  };
}

interface Props {
  token?: string;
}

class App extends React.Component<Props & StyledComponentProps> {
  public render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={ddaTheme}>
        <Router basename="/churnscore">
          <ScrollToTop />
          <div>
            <CssBaseline />
            <Switch>
              <Route
                path="/signin"
                render={(props) => (
                  <SignIn {...props} isAuthenticated={this.isAuthenticated()} />
                )}
              />
              <Route path="/impressum" component={Impressum} />
              <PrivateRoute
                isAuthenticated={this.isAuthenticated()}
                path="/effects"
                component={Effects}
              />
              <PrivateRoute
                isAuthenticated={this.isAuthenticated()}
                path="/documentation"
                component={Documentation}
              />
              <PrivateRoute
                isAuthenticated={this.isAuthenticated()}
                path="/customer_selection"
                component={CustomerGroups}
              />
              <PrivateRoute
                isAuthenticated={this.isAuthenticated()}
                path="/geoselection"
                component={Geoselection}
              />
              {isFeatureEnabled(process.env.REACT_APP_FEATURE_MARKETSHARE) && (
                <PrivateRoute
                  isAuthenticated={this.isAuthenticated()}
                  path="/marketshare"
                  component={MarketShare}
                />
              )}
              {isFeatureEnabled(process.env.REACT_APP_FEATURE_NBA) && (
                <PrivateRoute
                  isAuthenticated={this.isAuthenticated()}
                  path="/nba-evaluation"
                  component={NbaEvaluation}
                />
              )}
              {this.isAdmin() && (
                <PrivateRoute
                  isAuthenticated={this.isAuthenticated()}
                  path="/usermanagement"
                  component={UserManagement}
                />
              )}
              <PrivateRoute
                isAuthenticated={this.isAuthenticated()}
                path="/"
                component={Dashboard}
              />
            </Switch>
            {HostService.isTestStage() && (
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={true}
              >
                <SnackbarContent
                  className={classes && classes.error}
                  message={<span>Test System</span>}
                />
              </Snackbar>
            )}
            <ErrorSnackbar />
          </div>
        </Router>
      </MuiThemeProvider>
    );
  }

  private isAuthenticated = () => {
    return !!this.props.token;
  };

  private isAdmin = (): boolean => {
    const user = jwt.decode(this.props.token!);
    // tslint:disable-next-line: no-string-literal
    return !!user && user["role"] === RoleType.ADMIN;
  };
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
});

const ddaTheme = createMuiTheme({
  palette: {
    primary: { main: "#002E5F", light: "#33577f", dark: "#002042" },
    secondary: {
      contrastText: "#fff",
      main: "#00A8E1",
      light: "#33b9e7",
      dark: "#00759d",
    },
  },
  typography: {
    fontFamily: ["Arial", "sans-serif"].join(","),
  },
} as DDATheme);

export default connect(mapStateToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/App.tsx